//Emailjs Service File
const apiEmailjs = { 
    USER_ID: 'user_eNkaK7mB3QrINsVKu6YyS',
    TEMPLATE_ID: 'template_xxmrs18',
    SERVICE_ID: 'service_g9dsjrr',
    }

export default apiEmailjs;

